/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default { 

  resetStore() {
    // reset store to empty
    Store.dispatch('dailyYardVehicles/setDailyYardVehicles', {
      dailyYardVehicles: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['dailyYardVehicles/dailyYardVehicles'].length < 1) {
      try {
        const response = await Api(true).get('/daily_yard_vehicle/list_all');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('dailyYardVehicles/setDailyYardVehicles', {
              dailyYardVehicles: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('dailyYardVehicles.ts - listAll - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetYardStatusStore() {
    // reset store to empty
    Store.dispatch('dailyYardVehicles/setYardStatuses', {
      yardStatuses: [],
    });
  },

  async listAllYardStatuses(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['dailyYardVehicles/yardStatuses'].length < 1) {
      try {
        const response = await Api(true).get('/daily_yard_statuses/list_all');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetYardStatusStore();
            return response.data.message;
          } else {
            Store.dispatch('dailyYardVehicles/setYardStatuses', {
              yardStatuses: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('dailyYardVehicles.ts - listAllYardStatuses - 89 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    vehicle1Id: number,
    vehicle2Id?: number,
  }) {
    return Api(true).post('/daily_yard_vehicle/create', params);
  },

  updateStatus(params: {
    id: number,
    statusId?: number,
    comment?: string,
  }) {
    return Api(true).post('/daily_yard_vehicle/update_status', params);
  },

  search(config: {params: { 
    date: string,
  }}) {
    return Api(true).get('/daily_yard_vehicle/search', config);
  },

};
